import React from 'react';

import UserCareManagerIcon from '@hero/ui-kit/icons/utility/UserCareManagerIcon';
import { CareManager } from '../../types';
import useGetCareManagers from '../../api/useGetCareManagers';
import * as Style from './style.module.scss';

interface CareManagerBadgeByIdsProps {
    careManagerIds: number[] | null;
    careManager?: never;
}

interface CareManagerBadgeDirectProps {
    careManager: CareManager;
    careManagerIds?: never;
}

type CareManagerBadgeProps = (CareManagerBadgeByIdsProps | CareManagerBadgeDirectProps) & {
    className?: string;
    active?: boolean;
};

const CareManagerBadge: React.FC<CareManagerBadgeProps> = ({
    careManagerIds,
    careManager,
    className,
    active = false
}) => {
    const { data: careManagers } = useGetCareManagers();

    const resolved = React.useMemo(() => {
        if (careManager) return careManager;
        if (!careManagerIds?.length || !careManagers?.length) return null;
        return careManagers.find((cm) => careManagerIds.includes(cm.id)) ?? null;
    }, [careManager, careManagerIds, careManagers]);

    if (!resolved) {
        return <p>N/A</p>;
    }

    const avatarWrapperClass = `${Style.avatarWrapper} ${active ? Style.avatarWrapperActive : ''}`;

    return (
        <div className={`${Style.wrapper} ${className ?? ''}`}>
            <div className={avatarWrapperClass}>
                {resolved.image_url ? (
                    <img
                        src={resolved.image_url}
                        alt={`${resolved.first_name} ${resolved.last_name}`}
                        className={Style.avatar}
                    />
                ) : (
                    <div className={Style.avatarPlaceholder}>
                        <UserCareManagerIcon size="small" />
                    </div>
                )}
                {active && (
                    <div className={Style.checkmark}>
                        <svg viewBox="0 0 16 13" width="10" height="10">
                            <path
                                d="M1.1 7.1l1.7 1.7M5.1 11.3l9.5-9.5"
                                stroke="#fff"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                )}
            </div>

            <p>
                {resolved.first_name} {resolved.last_name}
            </p>
        </div>
    );
};

export default CareManagerBadge;
